import script from "./UiCheckboxGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./UiCheckboxGroup.vue?vue&type=script&setup=true&lang=js"

import "./UiCheckboxGroup.vue?vue&type=style&index=0&id=d3c9df3a&lang=scss"

const __exports__ = script;

export default __exports__